import { motion } from "framer-motion";
import { Tag, UserRound, FileText, Layers, Globe, Headphones } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const POINTS = [
  { icon: Tag, title: "Klare Preise", desc: "Feste monatliche Preise – ohne versteckte Kosten oder Überraschungen." },
  { icon: Globe, title: "Domain & Hosting inklusive", desc: "Alles Technische ist bereits enthalten. Sie brauchen keinen eigenen Vertrag." },
  { icon: UserRound, title: "Persönlicher Ansprechpartner", desc: "Ein fester Kontakt für Ihren Webauftritt – keine anonyme Hotline." },
  { icon: FileText, title: "Transparente Vertragslaufzeit", desc: "12 Monate Mindestlaufzeit, danach monatlich flexibel. Klar kommuniziert." },
  { icon: Layers, title: "Nachvollziehbarer Änderungsservice", desc: "Sie wissen genau, welche Änderungen in Ihrem Paket enthalten sind." },
  { icon: Headphones, title: "Betreuung inklusive", desc: "Wir kümmern uns um Technik, Wartung und Aktualisierungen je nach Paket." },
];

export default function Trust() {
  return (
    <section className="relative py-14 lg:py-20 border-t border-white/10" data-testid="trust">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-[#FF3B00]" /> Warum Landingsstrategie
          </Reveal>
          <h2 className="font-display text-4xl md:text-5xl leading-tight tracking-tight text-white uppercase">
            <MaskLineInView>Vertrauen durch</MaskLineInView>
            <MaskLineInView delay={0.1} className="text-[#FF3B00]">Transparenz.</MaskLineInView>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
              className="group bg-[#100b07] p-7 lg:p-8 hover:bg-[#0F0F0F] transition-colors duration-300"
            >
              <p.icon strokeWidth={1.3} className="h-7 w-7 text-[#FF3B00] mb-6" />
              <h3 className="font-display text-xl text-white mb-2">{p.title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
